import IconWrapper from './iconWrapper.component'
import SubMenuList from './subMenuList.component'
import { IWebMenu } from '../../../interfaces/webMenu'
import Link from 'next/link'
import { urlObjectFactoryForWebmenus } from '../../../utils/webmenus'
import { useAppContext } from '../../../context/siteMapContext'

interface isExtendedCardProps {
  webmenu: IWebMenu
}

const ExtendedCard: React.FC<isExtendedCardProps> = ({ webmenu }) => {
  const {
    name_HU,
    backgroundColor,
    iconColor,
    fontColor,
    iconUrl,
    childList = [],
  } = webmenu

  const { urlObject, asPath } = urlObjectFactoryForWebmenus(webmenu)
  const { highContrastOn } = useAppContext();

  return (
    <div
      style={{ backgroundColor: highContrastOn ? 'white' : backgroundColor }}
      className={`z-1 col-span-4 p-0 xl:p-6  rounded-[2rem] 2xl:col-span-6 h-card xl:h-extended-card`}
    >
      <div className='flex flex-row flex-nowrap w-full h-full gap-mobile xl:gap-desktop'>
        <Link href={webmenu.link ?? urlObject} as={webmenu.link ? undefined : asPath} >
          <a className='w-1/2 flex items-center justify-center h-full py-0 xl:py-6' target={webmenu.openNewTab ? '_blank' : '_self'}>
            <IconWrapper
              name={name_HU}
              iconColor={iconColor}
              fontColor={fontColor}
              iconUrl={iconUrl}
              large
            />
          </a>
        </Link>
        <div className='w-1/2 h-full'>
          <SubMenuList subMenus={childList} fontColor={fontColor} />
        </div>
      </div>
    </div>
  )
}

export default ExtendedCard
